import ipv4 from "./ipv4.js";

module.exports = class ipv6 extends ipv4 {};



// WEBPACK FOOTER //
// ./frontend/connection_tests/ipv6.js